import React from 'react';

import { Icon } from '@chakra-ui/react';

export const ArrowAttachIcon = props => (
  <Icon viewBox="0 0 24 24" color="inherit" h="full" w="full" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 12.75L18 11.25L6 11.25L6 12.75L18 12.75ZM15.182 7.00742L12 10.1894L8.81802 7.00742L9.87868 5.94676L11.25 7.31808L11.25 2.25L12.75 2.25L12.75 7.31808L14.1213 5.94676L15.182 7.00742ZM12 8.06808L11.9999 8.06801L12.0001 8.06801L12 8.06808ZM8.81802 16.9926L12 13.8106L15.182 16.9926L14.1213 18.0532L12.75 16.6819L12.75 21.75L11.25 21.75L11.25 16.6819L9.87868 18.0532L8.81802 16.9926ZM12 15.9319L12.0001 15.932L11.9999 15.932L12 15.9319Z"
      fill="currentColor"
    />
  </Icon>
);
